import React from 'react';
import PropTypes from 'prop-types';
import Select from 'components/shared/Select';
import styles from './styles.module.scss';

function HollowSelect(props) {
  return (
    <Select
      {...props}
      wrapperStyles={[styles.hollowWrapper, ...props.wrapperStyles]}
      nativeWrapperStyles={[styles.hollowNative]}
      labelStyles={[styles.hiddenLabel]}
      inputStyles={[styles.hollowInput]}
      chevronStyles={[styles.hollowChevron]}
    />
  );
}

HollowSelect.propTypes = {
  wrapperStyles: PropTypes.array
};

HollowSelect.defaultProps = {
  wrapperStyles: []
};

export default HollowSelect;
